// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  auditTrail as _auditTrail,
  collection as _collection,
  collectionChanges as _collectionChanges,
  collectionCount as _collectionCount,
  collectionCountSnap as _collectionCountSnap,
  collectionData as _collectionData,
  doc as _doc,
  docData as _docData,
  fromRef as _fromRef,
  snapToData as _snapToData,
  sortedChanges as _sortedChanges
} from 'rxfire/firestore';

export const auditTrail = ɵzoneWrap(_auditTrail, true);
export const collectionSnapshots = ɵzoneWrap(_collection, true);
export const collectionChanges = ɵzoneWrap(_collectionChanges, true);
export const collectionCount = ɵzoneWrap(_collectionCount, true);
export const collectionCountSnap = ɵzoneWrap(_collectionCountSnap, true);
export const collectionData = ɵzoneWrap(_collectionData, true);
export const docSnapshots = ɵzoneWrap(_doc, true);
export const docData = ɵzoneWrap(_docData, true);
export const fromRef = ɵzoneWrap(_fromRef, true);
export const snapToData = ɵzoneWrap(_snapToData, true);
export const sortedChanges = ɵzoneWrap(_sortedChanges, true);
